// @ts-nocheck
/* eslint-disable */
/* eslint-disable no-console */
import { dateFormat } from "~/util/format";
import ErrorStackParser from 'error-stack-parser';

const SEPARATOR = "|";

class ErrorLog {
	constructor() {
		this._errors = [];

		// zacneme zachytavat
		window.addEventListener("error", e => {
			this._insertError(e.message, e.error);
		});

		if (typeof console.error === "function") {
			let errorCb = console.error;

			console.error = function() {
				let args = Array.from(arguments);

				if (args.length) {
					// na prvnim radku je krpa
					let m = args[0].toString().split("\n");
					let error = m && m.length ? m[0] : "";

					this._insertError(error, args[0]);
				}

				errorCb.apply(errorCb, args);
			}.bind(this);
		}
	}

	/**
	 * Pridani chyby.
	 *
	 * @param {String} error Textovy popis chyby
	 */
	add(error) {
		if (typeof error == "string" && error) {
			this._errors.push(this._getTime() + SEPARATOR + error);
		}
	}

	/**
	 * Ziskani pole se vsemi chybami.
	 *
	 * @return  {Array[String]}
	 */
	get errors() {
		return this._errors;
	}

	_zlpad(value) {
		return ((value < 10 ? "0" : "") + value);
	}

	_getTime() {
		return (dateFormat(new Date(), `yyyy/mm/dd${SEPARATOR}hh:MM:ss`));
	}

	_insertError(error, stackTrace) {
		let parsed = this._parse(stackTrace);

		this._errors.push(this._getTime() + SEPARATOR + error + (parsed.length ? SEPARATOR + "trace" + SEPARATOR + parsed.join(SEPARATOR) : ""));
	}

	_parse(eStr) {
		let output = [];

		try {
			// muze vyhodit vyjimku
			let parsed = ErrorStackParser.parse(eStr);

			parsed.forEach(parItem => {
				let item = "column=" + parItem.columnNumber + ";line=" + parItem.lineNumber + ";file=" + parItem.fileName.replace(/.*\//, "").replace(/\?.*$/, "");

				if (parItem.functionName) {
					item += ";fn=" + parItem.functionName;
				}

				output.push(item);
			});
		}
		catch (e) {
			// nelze rozparsovat - zkusime vlozit jako string a max 100 znaku
			if (typeof eStr === "string") {
				output.push(`parse error: ${eStr.substr(0, 100)}`);
			}
		}

		return output;
	}
}

export default new ErrorLog();
